import init from "../../shared/utils/init"

init(() => {
  const descriptionField = document.querySelector(`.js-org-desc-max-length`)

  if (!descriptionField) return

  const descriptionInput = descriptionField.querySelector(`textarea`)
  const descriptionCounter = descriptionField.querySelector(
    `.js-org-desc-counter-value`
  )

  const updateDescriptionCounter = (e) => {
    const length = descriptionInput.value.length
    descriptionCounter.textContent = `${length}`

    if (length >= 1000) {
      e.preventDefault()
      descriptionInput.value = descriptionInput.value.slice(0, 1000)
    }
  }

  // Initialize counters
  updateDescriptionCounter()

  // Add input event listeners
  descriptionInput.addEventListener(`input`, updateDescriptionCounter)
  descriptionInput.addEventListener(`keyup`, updateDescriptionCounter)
  descriptionInput.addEventListener(`blur`, updateDescriptionCounter)
})
